module.exports = __webpack_public_path__ + "static/img/icon4_yc.765e0d9e.jpg";